<template>
    <p class="terms-and-spam-policy">
        <a
            class="terms-of-use"
            data-qa="terms-link"
            target="_blank"
            rel="noopener noreferrer"
            :href="termsLink"
        >
            {{ $t('myaccount.termsOfUse') }}
        </a>
        and
        <a
            class="spam-policy"
            data-qa="spam-link"
            target="_blank"
            rel="noopener noreferrer"
            :href="spamPolicyLink"
        >
            {{ $t('myaccount.spamPolicy') }}
        </a>
    </p>
</template>

<script>
const SPAM_POLICY_URL = 'https://www.keap.com/legal/aup';
const TERMS_OF_USE_URL = 'https://www.keap.com/legal/terms-of-use';

export default {
    data() {
        return {
            spamPolicyLink: SPAM_POLICY_URL,
            termsLink: TERMS_OF_USE_URL,
        };
    },
};
</script>

<style lang="scss" scoped>
.terms-and-spam-policy {

    .terms-of-use {
        color: $color-gray-800;
        text-decoration: underline;
    }

    .spam-policy {
        color: $color-gray-800;
        text-decoration: underline;
    }

    a {
        color: inherit;
        text-decoration: underline;

        &:hover {
            text-decoration: none;
        }
    }
}
</style>
